<template>
  <v-container pa-0 ma-0 fluid>
    <div class="section_inner mt-6">
      <v-row>
        <v-col cols="12" md="9">
          <h1 class="display-2 primary--text mt-0 mb-5">
            <v-icon color="primary--text" class="display-36 primary--text px-2">
              mdi-help-circle-outline
            </v-icon>
            אז איך נוכל לעזור לך?
          </h1>
          <QuestionsAndAnswers />
        </v-col>

        <v-col cols="12" md="3" class="hidden-sm-and-down">
          <PublishJobAd />
          <SectionCompaniesInnerPages :page="'helpPage'" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import SectionCompaniesInnerPages from '@/components/Jobs_List/SectionCompaniesInnerPages';
import PublishJobAd from '@/components/Jobs_List/Ads/PublishJobAd';
import QuestionsAndAnswers from '@/components/QuestionsAndAnswers/QuestionsAndAnswers';

export default {
  layout: 'innerPage',
  name: 'helpPage',

  components: {
    SectionCompaniesInnerPages,
    PublishJobAd,
    QuestionsAndAnswers,
  },

  head() {
    return {
      title: 'עזרה - דרושים IL',
      meta: [
        {
          name: 'description',
          content:
            'דרושים IL מבית יד 2, מציע לכם עזרה בכל נושא ו/או בעיה שנתקלתם בה בעת חיפוש עבודה. לרשותכם גישה לאלפי משרות בכל תחומי התעסוקה.',
          hid: 'DESCRIPTION',
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>
